// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import WebOrganisationListResultModel from '../../model/web-organisation-list-result-model';
import WebOrganisationListResultDTO from '../dto/web-organisation-list-result-dto';
import dtoSchema from '../schemas/web-organisation-list-result-schema';
import WebOrganisationModel from '../../model/web-organisation-model';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class WebOrganisationListResultModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<WebOrganisationListResultDTO>) {
    super();
    if (data) {
      this.items = data.items?.map((i) => WebOrganisationModel.toModel(i)) ?? [];
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
    }
  }
  /**
  */
  items?: WebOrganisationModel[];
  /**
  */
  links?: ResourceLinkModel[];

  static toModel(dto: DeepPartial<WebOrganisationListResultDTO>): WebOrganisationListResultModel;
  static toModel(dto: DeepPartial<WebOrganisationListResultDTO> | undefined | null): WebOrganisationListResultModel | undefined;
  static toModel(dto: DeepPartial<WebOrganisationListResultDTO> | undefined | null): WebOrganisationListResultModel | undefined {
    return dto ? new WebOrganisationListResultModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<WebOrganisationListResultModel> | WebOrganisationListResultModel): WebOrganisationListResultDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      items: unwrapped.items,
      links: unwrapped.links,
    } as WebOrganisationListResultDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for WebOrganisationListResultModel, can not map to WebOrganisationListResultDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
